import { Map } from 'immutable';

import * as constants from '../constants';

const initialState = Map({
  fileName: '',
  isLoading: false,
  previewImageURL: '',
});

const imageInjectionReducer = (state = initialState, { type, meta }) => {
  switch (type) {
    case constants.MOBILE_DEVICE_INJECT_IMAGE.REQUEST:
      return state.set('isLoading', true);
    case constants.MOBILE_DEVICE_INJECT_IMAGE.SUCCESS:
      return state.withMutations((mutable) => {
        mutable
          .set('isLoading', false)
          .set('previewImageURL', meta.previewImageURL)
          .set('fileName', meta.fileName);
      });
    case constants.MOBILE_DEVICE_INJECT_IMAGE.FAILURE:
      return state.set('isLoading', false);
    case constants.MOBILE_SESSION_STOP.SUCCESS: {
      return state.withMutations((mutable) => {
        mutable
          .set('isLoading', initialState.get('isLoading'))
          .set('previewImageURL', initialState.get('previewImageURL'))
          .set('fileName', initialState.get('fileName'));
      });
    }
    default:
      return state;
  }
};

export default imageInjectionReducer;
export { initialState };
